<template>
  <!-- <OriginalTinyMceEditor api-key="m9eo5iq42zwnpyan9hrvdit7s9wo7ih7hzbgkh2m62e6lim4" -->
  <OriginalTinyMceEditor
    v-model="content"
    @input="$emit('input', content)"
    :init="tinyMceEditorConfig"
    v-if="shown"
  ></OriginalTinyMceEditor>
</template>

<script>
// TinyMCE (self-hosted)
import "tinymce/tinymce";
// required since TinyMCE 6
import "tinymce/models/dom";

// style
// import 'tinymce/skins/ui/oxide/skin.css'
// import "tinymce/skins/ui/oxide/skin.min.css";
// import 'tinymce/skins/ui/oxide/content.inline.css'

/* content UI CSS is required */
// import contentUiSkinCss from "tinymce/skins/ui/oxide/content.css";
/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
// import contentCss from "tinymce/skins/content/default/content.css";

import "tinymce/themes/silver";

// icon
import "tinymce/icons/default";

// plugins
import "tinymce/plugins/advlist";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/code";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/table";
import "tinymce/plugins/template";
import "tinymce/plugins/wordcount";

import OriginalTinyMceEditor from "@tinymce/tinymce-vue";

export default {
  name: "TinyMceEditor",
  props: {
    value: String,
    customTemplates: Array,
    allowAllStyle: Boolean,
  },
  components: { OriginalTinyMceEditor },
  watch: {
    value(newVal) {
      this.content = newVal;
    },
  },
  data() {
    var v = this;
    return {
      shown: false,

      content: this.value,

      // Email Template
      tinyMceEditorConfig: {
        // skin: false,
        skin_url: "tinymce/skins/ui/oxide",
        // content_css: false,
        content_css: "tinymce/skins/content/default/content.min.css",
        // content_style: contentUiSkinCss.toString() + "\n" + contentCss.toString(),  // add styles as strings
        plugins:
          "advlist autoresize code image link lists table template wordcount",
        // toolbar: 'undo redo | fontsize | styles | bold italic underline strikethrough |  alignleft aligncenter alignright alignjustify | bullist numlist | link image | indent outdent | template',
        toolbar:
          "undo redo | fontsize | styles | bold italic underline strikethrough |  alignleft aligncenter alignright alignjustify | bullist numlist | link image | indent outdent",
        // content_css : "/tnc.css",
        // fix_list_elements: false,
        // element_format: 'html',
        // valid_children: '+ol[ol],+li[ol],+li[li],+li[ol]',
        min_height: 320,
        // TinyMCE 6 shows an "Upgrade" promo button in the toolbar unless disabled
        promotion: false,
        removed_menuitems: "fontfamily",
        image_advtab: true,
        images_upload_base_path: "/static/",
        images_upload_credentials: true,
        // TinyMCE 6: handler must return a Promise instead of taking success/failure callbacks
        images_upload_handler(blobInfo) {
          return new Promise(function (resolve, reject) {
            v.$uploadFiles(
              [blobInfo.blob()],
              function (response) {
                resolve(
                  "/api/static/" + response.body.file_ids[blobInfo.filename()]
                );
              },
              function (response) {
                reject(response.body.msg);
              }
            );
          });
        },
        templates: this.customTemplates
          ? this.customTemplates
          : [
              {
                title: "User Name (Chinese)",
                description: "",
                content: "{{user_name_zh}}",
              },
              {
                title: "User Name (English)",
                description: "",
                content: "{{user_name_en}}",
              },
              { title: "Url", description: "", content: "{{url}}" },
              {
                title: "Event Name (Chinese)",
                description: "",
                content: "{{event_name_zh}}",
              },
              {
                title: "Event Name (English)",
                description: "",
                content: "{{event_name_en}}",
              },
              {
                title: "Payment Details",
                description: "",
                content: "{{payment_detail}}",
              },
            ],
        image_list: [{ title: "QR Code", value: "/api/static/test_qr" }],
        invalid_styles: this.allowAllStyle
          ? ""
          : "font-size font-family line-height background-color background-image color",
      },
    };
  },
  mounted() {
    var v = this;

    setTimeout(() => {
      v.shown = true;
    }, 1000);
  },
};
</script>
